<template>
  <section>
    <section :class="['task-wrapper', isXl && 'isXl']">
      <div
        :class="['content']"
        :style="styleObj"
        v-if="actData.taskInfos && actData.taskInfos.length > 0"
      >
        <h3 class="title">邀请任务</h3>
        <p class="desc">邀请用户完成以下任务，可得相应奖励</p>
        <ul class="task-list">
          <TaskItem
            v-for="(task, index) in actData.taskInfos"
            :key="index"
            :task="task"
          />
        </ul>
      </div>
      <section v-else class="empty-task">
        <img
          class="xl_empty"
          src="../assets/images/no_trip.png"
          alt="空状态"
          v-if="isXl"
        />
        <img class="hll_empty" src="../assets/images/empty.png" alt="" v-else />
        <p class="desc">当前城市没有任何任务哦～</p>
      </section>
    </section>
  </section>
</template>
<script>
import TaskItem from './TaskItem';
import { mapState } from 'vuex';
import { isXL } from '../utils';

export default {
  components: { TaskItem },
  props: ['backgroundColor', 'fontColor'],
  mounted() {
    this.trackLogHandle();
  },
  computed: {
    ...mapState('app', ['actData', 'businessType']),
    isXl() {
      return isXL();
    },
    styleObj() {
      let style = {};
      return {
        ...style,
        backgroundColor: this.backgroundColor,
        color: this.fontColor
      };
    }
  },
  methods: {
    trackLogHandle() {
      let { taskInfos } = this.actData;
      let task_ids = (taskInfos && Array.isArray(taskInfos)
        ? taskInfos.map(item => item.taskId)
        : []
      ).join(',');
      this.trackLog('任务列表', false, {
        actEventType: 'invite_tasklist_expo',
        task_ids
      });
    }
  }
};
</script>
<style lang="less" scoped>
.task-wrapper {
  padding: 0 27px 30px;
  box-sizing: border-box;
  .content {
    box-sizing: border-box;
    padding: 35px;
    border-radius: 16px;
    // box-shadow: 0px 0px 40px 0px rgba(40, 82, 210, 0.48);
    font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
    font-weight: 500;
    letter-spacing: 1px;
    .title {
      font-size: 42px;
      font-weight: 700;
      font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;
    }
    .desc {
      font-size: 28px;
    }
  }
  &.isXl {
    padding-top: 16px;
    .content {
      border-radius: 16px;
    }
  }
}
.empty-task {
  background-color: #fff;
  padding: 45px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  > .xl_empty {
    height: 228px;
  }
  .hll_empty {
    height: 185px;
  }
  > .desc {
    font-size: 28px;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    font-weight: 400;
    text-align: left;
    color: #8c8c8c;
    margin-top: 25px;
  }
}
</style>
